import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=228a134b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServerError.vue"
export default component.exports